// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"
import LinkCore from "@material-ui/core/Link";
// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
import RightIcon from "@material-ui/icons/ArrowRightAlt"
import ForwardIcon from '@material-ui/icons/ArrowForwardIos';

import grey from "@material-ui/core/colors/grey"


// FLASH
//import FlashLogo from "../static/images/lightning-logo-transparent.png"
import FlashLogo from "../static/images/pulseai/pulseai.logo3.transparent.png";
import BrainSketch from "../static/images/brain-sketch7.png"
//import IDashScreenshot from "../static/images/idash-screenshot.png"
import IDashScreenshot from "../static/images/pulseai/idash-screenshot.png"

const styles = theme => ({


    fabDiv: {
        // position: "relative",
        // bottom: 50,
        // paddingRight: 20,
        display: "flex",
        justifyContent: "flex-end",
    },
    
    fab: {
        position: "fixed",
        //        bottom: theme.spacing(8),
        //        bottom: "5%",
        //        right: theme.spacing(1),
        //        left: "75%",
        // marginLeft: 400,
        //        marginLeft: "65%",
        //        marginTop: "-20%",
        zIndex: 10,

        width: 60,
        height: 60,


        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            // marginTop: "-10%",
            bottom: "5%",
            right: "8%",
        },

        
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            //            left: "60%",
            //            bottom: "20%",
            //            marginLeft: 400,
            //            marginLeft: "25%",
            //            marginTop: "0%",
        },

    },
    
    fabBlue: {
        color: theme.palette.common.white,
        //backgroundColor: theme.palette.custom.scrollDark,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
    },
    
    //
    // proper styles
    //

    "@keyframes loginAnimation":  {
        "0%": {
            opacity: 1,
        },

        "40%": {
            opacity: 1,
        },
        
        "99%": {
            opacity: 0,
            width: "100%",
            height: "100%",
        },

        "100%": {
            opacity: 0,
            width: 0,
            height: 0,
        }
    },

    
    logoRoot: {
        position: "fixed",
        top: 0,
        left: 0,
        
        display: "flex",
        alignItems: "center", // vertical center
        justifyContent: "center", // horizontal center

        width: "100%",
        height: "100%",
        background: theme.palette.primary.main,
        zIndex: 1000,

        animationName: "$loginAnimation",
        animationDuration: "4s",
        animationFillMode: "forwards",

        userSelect: "none",
        
    },

    logoImg: {

        width: "40%",
        maxWidth: 200,

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            // marginTop: -350,
            // marginTop: "-15%",
        },
        
    },

    // text page
    // here instead of intro we want to scroll
    // so position is not fixed
    introRoot: {
        //        position: "fixed",
        //        top: 0,
        //        left: 0,
        
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // vertical center
        justifyContent: "center", // horizontal center

        width: "100%",
        height: "100%",

        backgroundColor: "#FFFFFF",

        userSelect: "none",
        
    },

    introText: {
        //  margin: "auto",
        // marginTop: "18%",
        //
        // desktop - if more than 600
        //
        marginTop: "3em",
        [theme.breakpoints.up("md")]: {
            //marginTop: "5%",
            marginTop: "6em",
        },
        paddingLeft: 40,
        paddingRight: 40,
        maxWidth: 600,
        backgroundColor: "#FFFFFF",
        zIndex: 1000
    },

    titleText: {
        color: theme.palette.primary.main,
        fontSize: 24,
    },

    titleLogo: {
        marginRight: 5,
        marginBottom: 10,
        // paddingBottom: 10,
        //        marginTop: "18%",
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginBottom: -10,
        },

        //height: 62,
        //width: 62,

        height: 108,
        width: 216,
    },

    forwardArrow: {
        marginTop: -20,        
        width: 120,
        height: 120,
        color: theme.palette.primary.main,

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            marginTop: -72,
            marginLeft: -230,        
        },
    },

    policyDiv: {
//        marginTop: -8,
//        marginLeft: 20,
        //        marginRight: 20,
        marginLeft: -100
    },

    //
    // REGISTER STYLES
    //
    
    continueText: {
        marginBottom: "0px",
        marginRight: "18px",
        color: theme.palette.primary.main,
        fontSize: "16px",
        fontWeight: "700"
    },


    forwardButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        //justifyItems: "flex-center",
        width: "51px",
        height: "51px",
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.main,
        boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)",
        "&:hover": {
            backgroundColor: "#438cffc2"
        }
    },

    forwardArrow: {
        //marginTop: -20,        
        //width: "25",
        //height: "25",
        fontSize: "28px",
        color: "white",
        marginLeft: "4px",
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
//            marginTop: -72,
//            marginLeft: -230,        
        },
    }

    
    
})

let FaqComponent = withStyles(styles, { name: "FaqComponent" })(
    class FaqComponentBasis extends Component {

        // yes, we can redirect from children!

        state = {
            redirectToRegister: false,
            debugLayout: false
        }

        handleStartClick = () => {
            console.log("<Faq>: handleStartClick()")
            const { history, registerUrl } = this.props
            console.log("<Intro>: handleStartClick(): history =", history)
            history.push(registerUrl)
            //this.setState({redirectToRegister: true})
        }
        
        render() {

            const { classes, match, history } = this.props

            /*
            let registerUrl = "/register" // default
            if(match) {
                const { driveSlug } = match.params
                if(driveSlug) {
                    registerUrl = `/drives/${driveSlug}/register`
                }
            }
            */

            /*
            // redirects first
            if (this.state.redirectToRegister) {
                return <Redirect push to="/register"/>
            }
            */
            
            return(
                <div className={classes.introRoot}>
                  <div className={classes.introText}>
                    <div style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        backgroundColor: this.state.debugLayout ? grey[800] : "inherit",
                    }}>
                    <div className={classes.titleLogo} style={{
                        backgroundColor: this.state.debugLayout ? grey[800] : "inherit",
                    }}
                    >
                      <img alt="logo" src={FlashLogo} style={{width: "100%"}}/>
                    </div>
                    </div>
                    <div> 
                      <div className={classes.titleText}><b>FAQ</b></div>
                    </div>


                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;<b>-</b>&nbsp;&nbsp;PulseAI is not a survey. It is always on, with changing issues. Come back, often!
                    </Typography>
                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>&bull;</b>&nbsp;&nbsp;Bookmark PulseAI so you can easily return.
                    </Typography>


                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;<b>-</b>&nbsp;&nbsp;Your name and email are private. We do not retain them. We do not sell your information. Only your Representative will see personal information – just as if you had sent an email.
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;<b>-</b>&nbsp;&nbsp;When you open PulseAI, again, the last issue you submitted may not appear. Users can only submit comment on a particular issue once every 10 days.
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;<b>-</b>&nbsp;&nbsp;When submitting feedback, you may select to share your input with friends for more influence on your issue.
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography style={{fontSize: 17}} variant="body1">
                      <b>Why PulseAI?</b>
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      <b>Problem:</b> Over 1.5 Billion email are sent to Congress annually. from 100 million people;
                      state and local governments reported 500 million email, Senators average 25,000
                      email/day; House Members average 6,000. What are they supposed to do with that?
                      It’s just a lot of words.
                    </Typography>
                    
                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      Federal representatives get too much email; state, and local representatives get too
                      little – because most constituents don’t know them or how to reach them. We solve
                      both problems.
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      <b>Solution:</b> The PulseAI platform
                    </Typography>

                    <div style={{marginTop: "2em", marginBottom: "2em", display: "flex", alignItems: "center", justifyContent: "center"}}>
                      <img alt="brain-sketch" src={BrainSketch} style={{width: "50%"}}/>
                    </div>
                    
                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      <u><b>Your input is delivered to your representative in a live dashboard</b></u> in which relevant data
                      is displayed in graphical form. Representatives can view their constituent’s (aggregate)
                      concerns ranked by level of activity/interest. They can view rankings of the reasons for
                      concern for any issue. They can view trends of issues and level of concern - and more.
                      They can’t get this from email; and they need it.
                    </Typography>

                    <div style={{marginTop: "2em", marginBottom: "2em", display: "flex", alignItems: "center", justifyContent: "center"}}>
                      <img alt="idash-screnshot" src={IDashScreenshot} style={{width: "90%"}}/>
                    </div>

                    <div style={{marginTop: "3em", marginBottom: "5em", display: "flex", alignItems: "center", justifyContent: "center"}}>
                      <Typography style={{display: "inline"}} variant="body1">
                    </Typography>
                      <LinkCore href="https://actionablefeedback.company" variant="body1" underline="none" style={{fontSize: "1.5em", fontWeight: "bold"}}>
                       Read More
                     </LinkCore>
                    </div>
                  </div>
                </div>
            )
        }
    }
)

class Faq extends Component {

    render() {
        
        const { match, history } = this.props
        let registerUrl = "/contacts" // default
        if(match) {
            const { driveSlug } = match.params
            if(driveSlug) {
                registerUrl = `/drives/${driveSlug}/contacts`
            }
        }

	return(
            <React.Fragment>
	      <CssBaseline/>
              <FaqComponent history={history} registerUrl={registerUrl}/>
            </React.Fragment>
	)
    }
}

Faq.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, { name: "Faq" })(Faq)

